import { Link } from 'react-router-dom';

// Site-wide footer for the marketing/app pages (hidden inside the reader).
export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <img src="/logo.png" alt="" className="footer-logo" />
          <div>
            <div className="brand">ScrollWind</div>
            <p className="muted footer-tag">Your library, on every screen.</p>
          </div>
        </div>
        <nav className="footer-nav">
          <Link to="/features">Features</Link>
          <Link to="/about">About</Link>
          <Link to="/login">Sign in</Link>
          <a href="https://github.com/DDmonkeytron/ScrollWind/releases" target="_blank" rel="noreferrer">
            Get the app
          </a>
        </nav>
      </div>
      <div className="footer-legal muted">© {new Date().getFullYear()} ScrollWind</div>
    </footer>
  );
}
